module.exports = __webpack_public_path__ + "media/images/coke-ba0637b82019fa7b1a9e3c383bc4a3b6.svg";